import builder, { Builder, BuilderComponent } from "@builder.io/react";
import { notFound } from "next/navigation";

builder.init(process.env.NEXT_PUBLIC_BUILDER_API_KEY!);

export function NotFoundPage() {
  if (Builder.isPreviewing || Builder.isEditing) {
    return <BuilderComponent model="page" />;
  }

  return notFound();
}
